import React, { FunctionComponent } from "react"
import Upload from "../../../components/Upload/Upload"
import { iArTarget } from "../../../definitions/ArTarget"

interface iProps {
  item?: iArTarget
}

const ARTargetUploads: FunctionComponent<iProps> = ({ item }) => {
  return (
    <div className="scrollable">
      <Upload
        name="image"
        fileCollection="Files_ARTargetImages"
        maxFiles={1}
        initialFiles={[item?.image || ""]}
        label="Upload image"
      />
    </div>
  )
}

export default ARTargetUploads
